(function () {
  if (window.__npCartChildrenBound) return;
  window.__npCartChildrenBound = true;

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
  }

  function cartUpdateUrl() {
    var root =
      (window.Shopify && Shopify.routes && Shopify.routes.root) ||
      '/';
    if (window.theme && theme.routes && theme.routes.cartChange) {
      return theme.routes.cartChange
        .replace('change.js', 'update.js')
        .replace('/change', '/update');
    }
    return root + 'cart/update.js';
  }

  function clearCharmGroupUi(group) {
    if (!group) return;
    var addons = group.closest('[data-np-cart-addons]');
    var children = group.closest('.jsc-np-cart-children');
    group.remove();

    if (!addons) return;

    var panel = addons.querySelector('[data-np-cart-addons-panel]');
    var hasOtherAddons = !!(
      panel &&
      panel.querySelector('.jsc-np-cart-child, [data-np-line-key]')
    );

    if (hasOtherAddons) {
      // Remaining accessories/monogram still need a refresh for accurate totals.
      return;
    }

    addons.remove();

    if (children && !children.querySelector('.jsc-np-cart-child, [data-np-line-key]')) {
      children.remove();
    }
  }

  function removeAllCharms(group) {
    if (!group) return;
    var rows = group.querySelectorAll('[data-np-charm-key]');
    var parentKey = group.getAttribute('data-np-charm-parent-key');
    if (!rows.length && !parentKey) {
      clearCharmGroupUi(group);
      return;
    }

    var updates = {};
    rows.forEach(function (row) {
      var key = row.getAttribute('data-np-charm-key');
      if (key) updates[key] = 0;
    });
    if (parentKey) updates[parentKey] = 0;
    if (!Object.keys(updates).length) {
      clearCharmGroupUi(group);
      return;
    }

    group.setAttribute('aria-busy', 'true');

    fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('update failed');
        return res.json();
      })
      .then(function () {
        clearCharmGroupUi(group);
        refreshCart();
      })
      .catch(function (err) {
        group.removeAttribute('aria-busy');
        console.error('[NP] Failed to remove charms', err);
      });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target && event.target.closest
      ? event.target.closest('[data-np-cart-addons-toggle]')
      : null;
    if (toggle) {
      var root = toggle.closest('[data-np-cart-addons]');
      if (!root) return;
      var panel = root.querySelector('[data-np-cart-addons-panel]');
      var labelText = toggle.querySelector('[data-np-cart-addons-text]');
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      var nextExpanded = !expanded;
      toggle.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
      root.classList.toggle('is-collapsed', !nextExpanded);
      if (panel) panel.hidden = !nextExpanded;
      if (labelText) {
        labelText.textContent = nextExpanded
          ? (toggle.getAttribute('data-hide-label') || 'Hide Add-ons')
          : (toggle.getAttribute('data-show-label') || 'Show Add-ons');
      }
      return;
    }

    var removeAll = event.target && event.target.closest
      ? event.target.closest('[data-np-remove-all-charms]')
      : null;
    if (removeAll) {
      event.preventDefault();
      removeAllCharms(removeAll.closest('[data-np-cart-charm-group]'));
    }
  });
})();
